import { SERVER_URL } from '../utils/constants'

const getAudioBooksLinkId = async (payload) => {
    const {
        address,
        jwtToken
    } = payload


    const response = await fetch(
        `${SERVER_URL}/createAudioboooksAppLink`, {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            address,
            jwtToken
        }),
    }
    )
    if (response.status === 403) {
        throw new Error("Session expired")
    }
    if (response.status !== 200) {
        const text = await response.text();
        throw new Error(text); // return plain text response
    }
    const data = await response.json();
    return data.linkId;
}
export default getAudioBooksLinkId
